import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBillOfMaterials = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.6667 4.35L17.3333 3L16 4.35L14.6667 3L13.3333 4.35L12 3L10.6667 4.35L9.33333 3L8 4.35L6.66667 3L5.33333 4.35L4 3V21L5.33333 19.65L6.66667 21L8 19.65L9.33333 21L10.6667 19.65L12 21L13.3333 19.65L14.6667 21L16 19.65L17.3333 21L18.6667 19.65L20 21V3L18.6667 4.35ZM18.2222 18.381H5.77778V5.619H18.2222V18.381ZM6.66667 14.7H17.3333V16.5H6.66667V14.7ZM6.66667 11.1H17.3333V12.9H6.66667V11.1ZM6.66667 7.5H17.3333V9.3H6.66667V7.5Z",
		fill: "currentColor"
	})
});
export default SvgBillOfMaterials;
